import { Badge as r, badgeVariants as t } from "./Badge.js";
export {
  r as Badge,
  t as badgeVariants
};
